// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import type { CoqueRetailer, CrossSellBean } from '../../../../../types/apolloType';
import Loader from '../../../../common/Loader';
import retailerApi from '../../../../../network/api/retailerApi';
import CrossSellRetailer from './CrossSellRetailer';
import type { Store } from '../../../../../types/shoppingCenterType';

type Props = {
  shoppingCenterStores: Store[],
  currentRetailer: CoqueRetailer,
  sameBl1: boolean,
}

type State = {
  crossSells: CrossSellBean[],
  crossSellIsLoading: boolean,
  limit: number,
}

class CrossSell extends React.Component<Props, State> {
  state = {
    crossSells: [],
    crossSellIsLoading: true,
    limit: 5,
  }

  fetchCrossSell = (retailerId: number, limit: number, sameBl1: boolean) => {
    this.setState({
      crossSellIsLoading: true,
    });
    retailerApi.fetchCrossSellByRetailerId(retailerId, limit, sameBl1)
      .then(response => response.json())
      .then((crossSellList: CrossSellBean[]) => {
        this.setState({
          crossSells: crossSellList,
        });
      })
      .finally(() => {
        this.setState({
          crossSellIsLoading: false,
        });
      });
  }

  componentDidMount() {
    this.fetchCrossSell(
      this.props.currentRetailer.codeRetailerProposition,
      this.state.limit,
      this.props.sameBl1,
    );
  }

  shouldComponentUpdate(nextProps: Props, nextState: State, nextContext: any): boolean {
    if (this.props.currentRetailer.codeRetailerProposition
      !== nextProps.currentRetailer.codeRetailerProposition) {
      nextState.limit = 5;
      this.fetchCrossSell(
        nextProps.currentRetailer.codeRetailerProposition,
        nextState.limit,
        nextProps.sameBl1,
      );
    }
    return true;
  }

  isInShoppingCenter = (codensg: string) => (
    this.props.shoppingCenterStores.filter((store: Store) =>
      (store.retailerId === codensg)).length > 0
  );

  render() {
    if (this.state.crossSellIsLoading && this.state.crossSells.length < 1) {
      return (
        <div className="cross-sell">
          <Loader isLoading />
        </div>
      );
    }
    return (
      <div className="cross-sell">
        <div className="cross-sell-title">
          <Translate
            value={`clusters.tlp.title${this.props.sameBl1 ? '_same_bl1' : ''}`}
            currentBL={this.props.currentRetailer.bl1Name}
          />
        </div>
        <div className="cross-sell-subtitle">
          <Translate
            value={`clusters.tlp.subtitle${this.props.sameBl1 ? '_same_bl1' : ''}`}
            currentRetailer={this.props.currentRetailer.retailerName}
          />
        </div>
        <div className="cross-sell-legend">
          <div className="cross-sell-legend-example cross-sell-retailer--border" />
          <Translate value="clusters.tlp.legend" />
        </div>
        {
          this.state.crossSells.map((crossSell: CrossSellBean) => (
            <CrossSellRetailer
              key={crossSell.crossedRetailerId}
              isInShoppingCenter={this.isInShoppingCenter(crossSell.crossedRetailerId)}
              crossSell={crossSell}
            />
          ))
        }
        {
          this.state.crossSells && this.state.crossSells.length > 0
            ? (
              <button
                className="apollo-button-contained"
                disabled={this.state.crossSellIsLoading || this.state.limit > this.state.crossSells.length}
                onClick={() => {
                  this.setState(
                    {
                      limit: this.state.limit + 5,
                    },
                    () => this.fetchCrossSell(
                      this.props.currentRetailer.codeRetailerProposition,
                      this.state.limit,
                      this.props.sameBl1,
                    ),
                  );
                }}
              >
                {
                  this.state.crossSellIsLoading
                    ? (
                      <i className="fa fa-spinner fa-spin" />
                    ) : (
                      <Translate value="clusters.tlp.see_more" />
                    )
                }
              </button>
            )
            : (
              <h3 className="no-cluster"><Translate value="clusters.tlp.no_clusters" /></h3>
            )
        }
      </div>
    );
  }
}

export default CrossSell;

